var map = {
	"./de/warrior-name.png": "s3hf",
	"./en/warrior-name.png": "8uM4",
	"./es/warrior-name.png": "ceZV",
	"./fr/warrior-name.png": "m/UH",
	"./ja/warrior-name.png": "5ezK",
	"./ko/warrior-name.png": "ZoJ4",
	"./pt/warrior-name.png": "JAoE",
	"./ru/warrior-name.png": "ivSx",
	"./th/warrior-name.png": "Rr2n",
	"./zh-Hant/warrior-name.png": "44sn"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "jUGr";